import * as moment from 'moment';
import instances from './map';

/*
export const generateTokenSalesForce = () => {
  const tokenTime = localStorage.getItem('tokenTime');

  if (tokenTime === null || tokenTime <= Date.now())
    return instances
      .aws({
        url: '/prod/sales-force/token'
      })
      .then(response => {
        const bearer = `Bearer ${response.data.access_token}`;
        instances.salesforce.defaults.headers.common.Authorization = bearer;
        localStorage.setItem('tokenTime', response.data.expires_in);
        localStorage.setItem('token', response.data.access_token);
        return response.data;
      })
      .catch(err => new Error(err));

  const bearer = localStorage.getItem('token');
  instances.salesforce.defaults.headers.common.Authorization = `Bearer ${bearer}`;
};
*/
export const generateTokenFallback = key => {
  const tokenName = `${key}Token`;

  return instances[key]({
    method: 'POST',
    url: '/oauth/access-token',
    data: { grant_type: 'client_credentials' }
  })
    .then(response => {
      instances[key].defaults.headers.access_token = response.data.access_token;
      localStorage.setItem(tokenName, response.data.access_token);
      localStorage.setItem(
        `${tokenName}Time`,
        moment()
          .add(1, 'hours')
          .unix()
      );

      return response.data;
    })
    .catch(() =>
      Promise.reject(
        new Error(
          'Não foi possivel fazer a autenticação para este serviço no momento, tente novamente.'
        )
      )
    );
};

export const generateToken = key => {
  const tokenName = `${key}Token`;
  const tokenValue = localStorage.getItem(tokenName);
  const tokenTimer = localStorage.getItem(`${tokenName}Time`);

  if (tokenValue === null || tokenTimer < moment().unix()) {
    return instances[key]({
      method: 'POST',
      url: '/oauth/access-token',
      data: {
        grant_type: 'client_credentials'
      },
      timeout: 2000
    })
      .then(response => {
        instances[key].defaults.headers.access_token = response.data.access_token;
        localStorage.setItem(tokenName, response.data.access_token);
        localStorage.setItem(
          `${tokenName}Time`,
          moment()
            .add(1, 'hours')
            .unix()
        );

        return response.data;
      })
      .catch(() =>
        Promise.reject(
          new Error(
            'Não foi possivel fazer a autenticação para este serviço no momento, tente novamente.'
          )
        )
      );
  }

  instances[key].defaults.headers.access_token = tokenValue;
};

export const generateTokenLogin = (codigo, senha) => {
  const tokenName = `prestador_odontoToken`;
  const tokenValue = localStorage.getItem(tokenName);
  if (tokenValue != null) {
    localStorage.removeItem(tokenName);
  }

  const encodedString = window.btoa(`${codigo}:${senha.replace(':', '#dOiS-pOnToS#')}`);

  return instances
    .prestador_odonto({
      method: 'POST',
      url: '/oauth/access-token',
      data: {
        grant_type: 'client_credentials'
      },
      timeout: 6000,
      headers: {
        'X-Authorization': encodedString,
        access_token: undefined
      }
    })
    .then(response => {
      instances.prestador_odonto.defaults.headers.access_token = response.data.access_token;
      localStorage.setItem(tokenName, response.data.access_token);
      localStorage.setItem('codDentista', codigo);

      return response.data;
    })
    .catch(() =>
      Promise.reject(
        new Error(
          'Não foi possivel fazer a autenticação para este serviço no momento, tente novamente.'
        )
      )
    );
};

export const generateToken_ME = key => {
  const tokenName = `${key}Token`;
  const tokenValue = localStorage.getItem(tokenName);
  const tokenTimer = localStorage.getItem(`${tokenName}Time`);

  if (tokenValue === null || tokenTimer < moment().unix()) {
    return instances[key]({
      method: 'POST',
      url: '/oauth/access-token',
      data: {
        grant_type: 'client_credentials'
      }
    })
      .then(response => {
        instances[key].defaults.headers.access_token = response.data.access_token;
        localStorage.setItem(tokenName, response.data.access_token);
        localStorage.setItem(
          `${tokenName}Time`,
          moment()
            .add(1, 'hours')
            .unix()
        );

        return response.data;
      })
      .catch(err => {
        console.error('Erro na criação do token', err.message);
        return Promise.reject(new Error('Não foi possível completar esta ação.'));
      });
  }

  instances[key].defaults.headers.access_token = tokenValue;
};

export default generateToken;
